import React from 'react';
import PropTypes from 'prop-types';

import { StarRow } from '../RacingThemeSearch/RacingThemeSearchIcons';
import styles from './RacingThemeSearchRatingRow.module.css';

/**
 * Search filter minimum-rating radio row — static visual port.
 */
const RacingThemeSearchRatingRow = props => {
  const { filledStars, checked = false, name = 'rating' } = props;

  return (
    <label className={styles.ratingRow}>
      <input type="radio" name={name} defaultChecked={checked} readOnly />
      <span className={styles.starsMini}>
        <StarRow filledStars={filledStars} />
      </span>
      &amp; up
    </label>
  );
};

RacingThemeSearchRatingRow.propTypes = {
  filledStars: PropTypes.number.isRequired,
  checked: PropTypes.bool,
  name: PropTypes.string,
};

export default RacingThemeSearchRatingRow;
